import { IDefenseEventSimpleProps } from '../../types';
import { IPaginationParams } from '../../../../types';
import { queryClient } from 'index';
import { getUserId } from '../../../../DefaultService';

export const DEFENSE_EVENTS_CACHE_KEY = 'defenseEvents';

const USER_ID = getUserId();

export const useDefenseEventDataStreamCache = () => {
  return {
    getCacheData: (pagination: IPaginationParams): any[] | undefined =>
      queryClient.getQueryData<IDefenseEventSimpleProps[]>([
        `${DEFENSE_EVENTS_CACHE_KEY}${pagination.pageNumber}`,
        pagination,
        USER_ID,
      ]),
    setCacheData: (
      data: IDefenseEventSimpleProps[],
      pagination: IPaginationParams,
    ) =>
      queryClient.setQueryData(
        [
          `${DEFENSE_EVENTS_CACHE_KEY}${pagination.pageNumber}`,
          pagination,
          USER_ID,
        ],
        data,
      ),
    clearCacheData: () => {
      queryClient
        .getQueryCache()
        .getAll()
        .forEach(({ queryKey }) => {
          if (
            Array.isArray(queryKey) &&
            queryKey[0].startsWith(DEFENSE_EVENTS_CACHE_KEY) &&
            queryKey[2] == USER_ID
          ) {
            queryClient.removeQueries({ queryKey });
          }
        });
    },
  };
};
